import { gql } from '@apollo/client';

export const GENERATE_SIGNED_URL = gql`
    mutation generateSignedUrl($input: GenerateSignedUrlInput!) {
        generateSignedUrl(input: $input) {
            url
            signedUrl
        }
    }
`;
export const GENERATE_SIGNED_TAFFI_URL = gql`
    mutation GenerateSignedTaffiUrl($input: GenerateSignedUrlInput!) {
        generateSignedTaffiUrl(input: $input) {
            url
            signedUrl
        }
    }
`;
